<template>
  <div class="mobile-menu" @click="toggleMenu">
    <Icon v-if="display" name="close" class="mobile-menu__action" :size="25" :key="display" />
    <Icon v-if="!display" name="burger" class="mobile-menu__action" :size="32" :key="display" />
  </div>
</template>

<script>
import { ref, toRefs, watch } from '@vue/composition-api';
import Icon from '@/lego/components/icons/Icon.vue';

export default {
  components: {
    Icon,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const display = ref(value.value);

    watch(value, val => (display.value = val));

    function toggleMenu() {
      display.value = !display.value;
      emit('input', display.value);
    }

    return {
      display,
      toggleMenu,
    };
  },
};
</script>

<style lang="postcss" scoped>
.mobile-menu {
  @apply flex gap-xxxs;

  &__action.icon {
    @apply cursor-pointer lg:hidden;
  }
}
</style>
